import { Controller } from '@hotwired/stimulus'

// Lleva a la vista el aviso de formulario bloqueado cuando aparece fuera de pantalla.
//
// El ancla del redirect cubre la vía sin JS, pero no la del Turbo Stream: ahí el
// contenedor se reemplaza en su sitio y NADA hace scroll. Medido en móvil (390x844)
// con el formulario largo de macroeventos, el aviso se inyectaba a 1465px del
// viewport — el usuario veía que el botón "no hacía nada". Como el stream reemplaza
// el contenedor, este controlador vuelve a conectar y corrige.
//
// No scrollea si el aviso ya se ve: así no pelea con el salto del ancla ni mueve la
// página cuando el usuario ya está mirando el mensaje.
export default class extends Controller {
  connect () {
    if (!this.element.textContent.trim()) return
    if (this.estaEnPantalla()) return

    this.element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  estaEnPantalla () {
    const caja = this.element.getBoundingClientRect()
    return caja.top >= 0 && caja.bottom <= window.innerHeight
  }
}
